export default (): string | null => {
  return sessionStorage.getItem("@isAdm");
};
